import { render, staticRenderFns } from "./ReceptionContactEditor.vue?vue&type=template&id=b7594264&scoped=true&"
import script from "./ReceptionContactEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionContactEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7594264",
  null
  
)

export default component.exports